import type { Uuid } from '../contract.js';

/** Change a row only with the item that ships its destination (MA4/MA5). */
export const AREA_ADDRESS = {
  people: '/admin/people',
  sources: '/admin/sources',
  privacy: '/admin/privacy',
  spend: '/admin/spend',
  decides: '/admin/decides',
  policy: '/admin/policy',
  vault: '/admin/vault',
  powers: '/admin/powers',
  changes: '/admin/people/changes',
  add: '/admin/people/add',
  person: (principalId: Uuid) => `/admin/people/person/${encodeURIComponent(principalId)}`,
  group: (groupId: Uuid) => `/admin/people/group/${encodeURIComponent(groupId)}`,
} as const;

export type Area = Exclude<keyof typeof AREA_ADDRESS, 'person' | 'group'>;
export type AreaTarget = { area: Area } | { person: Uuid } | { group: Uuid };
export function addressOf(target: AreaTarget): string {
  if ('person' in target) return AREA_ADDRESS.person(target.person);
  if ('group' in target) return AREA_ADDRESS.group(target.group);
  return AREA_ADDRESS[target.area];
}
